import React from 'react'
import { faCodeBranch } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from '@nic/commons'
import { TabTitle } from '../../../Various/TabTitle/TabTitle'
import { CustomTabPane } from '../CustomTabPane'
import { RequestTabType } from '../../index'
import { TabPaneProps } from 'antd'
import { SummaryRequestTabController } from './SummaryRequestTabController'
import { useAssignmentRequest } from '../../../AssignmentRequests/useAssignmentRequest'
import { isRegistrarUserDomain } from '../../../User/utils'
import { useAuth } from '@nic/kc-auth'

export interface SummaryRequestTabProp extends TabPaneProps {
  onChangeTab: (index: RequestTabType | string) => void
  onEdit?: (edit: boolean) => void
  onEditOff?: () => void
  edit?: boolean
  hasAssignmentRequestPermission?: boolean
  disabledEdit?: boolean
  tabKey: RequestTabType
}

/**
 * SummaryRequestTab, tab che visualizza il riepilogo delle informazioni della richiesta
 * @param props
 * @constructor
 */
export const SummaryRequestTab: React.FC<SummaryRequestTabProp> = (props) => {
  const t = useTranslation()
  const { isRegistrarAssignedUser, isRegistrarAssigned } =
    useAssignmentRequest()
  const {keycloak} = useAuth()
  const hasEditPermission =
    isRegistrarAssignedUser ||
    // isUserAdmin ||
    !(isRegistrarAssigned && keycloak && isRegistrarUserDomain(keycloak))
  // Guardare
  // https://stackoverflow.com/questions/54015086/how-to-prevent-child-component-from-re-rendering-when-using-react-hooks-and-memo

  return (
    <CustomTabPane
      tab={<TabTitle iconType={faCodeBranch} text={`${t('tabReqSummary.title')}`} />}
      key={props.tabKey}
    >
      <SummaryRequestTabController {...props} hasAssignmentRequestPermission={hasEditPermission} />
    </CustomTabPane>
  )
}
